import { Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Chip } from "@mui/material";
import MainApiService from "../../../../services/mainApi.service";
import { IMemberAvailabilityPauseReason } from "../../../../models/member-availability-pause-reason";

const MEMBER_AVAILABILITY_PAUSE_REASON_ROUTE =
  process.env.REACT_APP_TICKETS +
  "/api/v1/TicketChannelMemberAvailabilityPauseReason/";
const memberAvailabilityPauseReasonService =
  new MainApiService<IMemberAvailabilityPauseReason>(
    MEMBER_AVAILABILITY_PAUSE_REASON_ROUTE
  );

const translationPath = "chatBot.page.service.memberAvailabilityPauseReason.";
export const MemberAvailabilityPauseReasonPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<IMemberAvailabilityPauseReason>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "code",
      headerName: t(translationPath + "code") || "Code",
      renderCell: (params) => params.value ?? "-",
    },
  ];
  const handleRowClick = (
    params: GridRowParams<IMemberAvailabilityPauseReason>
  ) => {
    console.log(params);
    navigate(`${params.id}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<IMemberAvailabilityPauseReason>
      showDefaultMacroFilters={false}
      service={memberAvailabilityPauseReasonService}
      columns={columns}
      title={
        t(translationPath + "member_availability_pause_reason") ||
        "Member Availability Pause Reason"
      }
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search") ||
        "Search for member availability pause reason"
      }
      addButtonLabel={
        t(translationPath + "add_member_availability_pause_reason") ||
        "Add member availability pause reason"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};
